import { createContext, useContext } from 'react';

export interface BatchMetricEntry {
  current: { value: number } | null;
  previous?: { value: number } | null;
}

export type BatchMetricsResult = Record<string, BatchMetricEntry>;

export interface StatCardsBatchContextValue {
  data: BatchMetricsResult | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export const StatCardsBatchContext = createContext<StatCardsBatchContextValue>({
  data: undefined,
  isLoading: false,
  isError: false,
  error: null,
});

export function useStatCardsBatchContext(): StatCardsBatchContextValue {
  return useContext(StatCardsBatchContext);
}
